import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { deleteItem } from '../../../api/items';

import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';
import { generateItemCIDKey } from '../../../components/Items/utils/generateItemCIDKey';

export const removeItem = createAsyncThunk(
  'items/removeItem',
  async ({ path, body, params }, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const response = await deleteItem(
        { path, body, params },
        {
          cancelToken: source.token,
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.status);
    }
  },
);

export const removeItemExtraReducers = builder => {
  builder
    .addCase(removeItem.pending, (state, action) => {
      const itemCIDKey = generateItemCIDKey(action.meta.arg.path);
      checkAndSetLoadingWithId(
        state.items.item.actions.delete.request,
        action,
        itemCIDKey,
      );
    })
    .addCase(removeItem.fulfilled, (state, action) => {
      const itemCIDKey = generateItemCIDKey(action.meta.arg.path);

      onMatchedRequest(
        state.items.item.actions.delete.request[itemCIDKey],
        action,
        () => {
          const removedFromAllIds = state.items.item.allIds.filter(
            id => id !== itemCIDKey,
          );
          const removedFromLayout = state.items.display.layout.filter(
            ({ id }) => id !== action.meta.arg.path.streamItemId,
          );

          delete state.items.item.byId[itemCIDKey];
          state.items.item.allIds = [...removedFromAllIds];
          state.items.display.layout = [...removedFromLayout];
        },
      );
    })
    .addCase(removeItem.rejected, (state, action) => {
      const itemCIDKey = generateItemCIDKey(action.meta.arg.path);

      handleRequestRejection(
        state.items.item.actions.delete.request[itemCIDKey],
        action,
      );
    });
};
